import {ChangeDetectionStrategy, Component, OnDestroy, OnInit} from '@angular/core';

import {CMP} from '@atmi/core/models';

import {BaseCtrlValueAccessorFormComponent} from '@sim/form/components/base-ctrl-value-accessor-form.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-cmp-form',
  styleUrls: ['./cmp-form.component.scss'],
  templateUrl: './cmp-form.component.html',
})
export class CmpFormComponent extends BaseCtrlValueAccessorFormComponent<CMP> implements OnDestroy, OnInit {

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    const cmpd = this.form?.get('CMPD');
    if (cmpd && !cmpd.value) {
      cmpd.setValue(new Date());
    } else if (cmpd && !(cmpd.value instanceof Date)) {
      const d = new Date(cmpd.value);
      if (d.toString() === 'Invalid Date' || isNaN(d.getTime())) {
        cmpd.setValue(new Date());
      }
      cmpd.setValue(d);
    }
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
